import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import JwtService from "services/jwt-service";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "core/LayoutContainers/DashboardLayout";
import DashboardNavbar from "core/Navbars/DashboardNavbar";
import Footer from "core/Footer";

const AdminProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(null);
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    
    // Check if user is admin
    if (token && JwtService.isAdmin(token)) {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
      // Redirect to financial hub after a delay to show error message
      setTimeout(() => {
        navigate("/financial-hub");
      }, 3000);
    }
  }, [navigate]);

  // Show loading state while checking
  if (isAdmin === null) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
          <MDTypography variant="h5" color="text">
            Checking permissions...
          </MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  // Show error message if not admin
  if (!isAdmin) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="60vh" flexDirection="column">
          <MDTypography variant="h4" color="error" mb={2}>
            Access Denied
          </MDTypography>
          <MDTypography variant="h6" color="text">
            You do not have permission to access this page.
          </MDTypography>
          <MDTypography variant="body2" color="text" mt={2}>
            Redirecting to dashboard...
          </MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return children;
};

AdminProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminProtectedRoute;